import { FC } from 'react';
import Image from 'next/image';
import styles from './FindProStep.module.scss';

interface Props {
  description: string;
  imageUrl: string;
  title: string;
}

export const FindProStep: FC<Props> = ({ description, imageUrl, title }) => (
  <div className={styles['container']}>
    <Image
      alt={title}
      className={styles.image}
      height={100}
      src={imageUrl}
      unoptimized={true}
      width={100}
    />

    <div className={styles['text']}>
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  </div>
);

export default FindProStep;
export type { Props as FindProStepProps };
